export default "/_next/static/chunks/fonts/Raleway Thin-d76a44780ad4b19c2b142cd93b8973e2.ttf";